import { CommandDispatcher } from "../../shared/domain/CommandDispatcher";

export class RegenerateInvoiceWithUpdatedTaxDataCommand {
  constructor(
    private readonly dispatcher: CommandDispatcher,
  ) {}

  run(service_delivery_id, charge_id, charge_amount, business_name, business_id, postal_address, post_code, province): Promise<{ [key: string]: string; }> {
    let args = {
      service_delivery_id:service_delivery_id,
      charge_id:charge_id,
      charge_amount:charge_amount,
      business_name: business_name,
      business_id: business_id,
      postal_address: postal_address,
      post_code: post_code,
      province: province,
    };
    try {
      return this.dispatcher.dispatch('regenerate.invoice.with.updated.taxdata', args);
    } catch(error) {
      console.error('Error al realizar la operación.', error)
    }
  }
}